export const namePattern = /^[^#:"<>[\]\\;~`!$%^*+={}|?/_&@0-9]{1,255}$/;
export const onlyOneSpacePattern = /^(?!.*\s{2,}).*$/;
